import React from 'react';
import { Modal, Icon } from 'antd';
import PropTypes from 'prop-types';

import './style.css';
import { setIcon } from '../../services/setIcon';

const ModalInfoComponent = (
  { title, content, cancelText, okText, id, onOk, onCancel,
    onVisible = false, children, icon, extraFunctionClose }) => {

  return (
    <Modal
      visible={onVisible}
      onCancel={() => { onCancel(id); extraFunctionClose && extraFunctionClose() }}
      cancelText={cancelText}
      okText={okText}
      onOk={onOk}
    >
      <h3 className="font-semibold title">{icon && <Icon component={setIcon(icon)} />} {title}</h3>
      {content && <p>{content}</p>}

      {children}
    </Modal>
  );
}


ModalInfoComponent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  cancelText: PropTypes.string,
  okText: PropTypes.string,
  id: PropTypes.string.isRequired,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  onVisible: PropTypes.bool,
  children: PropTypes.node,
  icon: PropTypes.string,
  extraFunctionClose: PropTypes.func,

}

export default ModalInfoComponent;
